import styled from 'styled-components'

export const Container = styled.main`
  padding-top: 72px;
  min-height: 100vh;
`
